import { ArrowRight, BarChartBigIcon, ShieldIcon, UsersRoundIcon } from "lucide-react";
import { getSeq } from "../../../../../helpers/get-seq";
import head from "../../../../assets/images/landing-page/head.png";
import { Button } from "../../../utils/landing-page/button";
import { Card } from "../../../utils/landing-page/card";
import "./index.scss";
import { useNavigate } from "react-router-dom";

export const AproposSection = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <ShieldIcon className="AproposSection-featureIcon" />,
      text: "Sécurisée",
    },
    {
      icon: <UsersRoundIcon className="AproposSection-featureIcon" />,
      text: "Multi-Sectoriel",
    },
    {
      icon: <BarChartBigIcon className="AproposSection-featureIcon" />,
      text: "Performante",
    },
  ];

  return (
    <section id="apropos" className="AproposSection">
      <div className="AproposSection-mainContainer">
        <div className="AproposSection-contentSection">
          <div className="AproposSection-titleSection">
            <h2 className="AproposSection-mainTitle">Plateforme Nationale</h2>
            <h2 className="AproposSection-subTitle">
              d&apos;Interopérabilité
            </h2>
          </div>

          <div>
            <div className="AproposSection-descriptionContainer">
              <p className="AproposSection-descriptionText">
                Cette plateforme constitue une solution stratégique destinée à accompagner le secteur public dans l’accélération de la mise en œuvre des référentiels de l’État béninois, avec pour objectif principal l’optimisation des processus décisionnels au service de l’administration publique.
              </p>
            </div>
          </div>

          <div>
            <div className="AproposSection-buttonContainer">
              <Button className="AproposSection-accessButton" 
              onClick={() => navigate("/app")}>
                Accéder à la plateforme
                <ArrowRight />
              </Button>
            </div>
          </div>

          <div>
            <div className="AproposSection-featuresContainer">
              {features.map((feature, index) => (
                <Card
                  key={`landingpage-feature--${getSeq()}-${index}`}
                  className="AproposSection-featureCard"
                >
                  <div className="AproposSection-featureIconWrapper">
                    {feature.icon}
                  </div>
                  <span className="AproposSection-featureText">{feature.text}</span>
                </Card>
              ))}
            </div>
          </div>
        </div>

        <div className="AproposSection-imageSection">
          <div className="AproposSection-imageContainer">
            <div className="AproposSection-pulseEffect" />
            <img
              className="AproposSection-image"
              alt="Automation of backend processes"
              src={head}
            />
            {/* <Lottie animationData={animationData} loop={true} /> */}
          </div>
        </div>
      </div>
    </section>
  );
};
